import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('@media only screen and (max-width: 1250px) and (min-width: 560px)', {
    $nest: {
        '.tb-page-header-search': {
            position: 'absolute',
            right: '20px',
            zIndex: 1,
        },
    }
});

cssRule('.tb-omnibox', {
    display: 'inline-block',
    verticalAlign: 'inherit',
    position: 'relative',
    textAlign: 'left',
    width: '100%',
    maxWidth: 'initial',
    height: '32px',
});

cssRule('.tb-omnibox.for-serp', {
    width: '560px',
});

cssRule('.tb-omnibox.for-serp .tb-omnibox-search-box', {
    position: 'relative',
    display: 'block',
});

cssRule('.tb-omnibox.for-serp .tb-omnibox-search-box .search', {
    display: 'block',
    width: '100%',
});

cssRule('.tb-omnibox.for-serp .tb-omnibox-search-box .search input', {
    width: '100%',
});

cssRule('.tb-omnibox.for-serp .tb-omnibox-press-enter-to-see-all', {
    top: 0,
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box', {
    display: 'flex',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box.not-active-keyboard-navigation-item input:focus', {
    /* error: '-moz-box-shadow': 'none', */
    '-webkit-box-shadow': 'none',
    boxShadow: 'none',
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box input', {
    width: '370px',
    height: '32px',
    fontSize: '14px',
    transition: 'width 0.25s ease-in-out',
    /* error: '-o-transition': 'width 0.25s ease-in-out', */
    '-moz-transition': 'width 0.25s ease-in-out',
    '-webkit-transition': 'width 0.25s ease-in-out',
    /* error: '-khtml-transition': 'width 0.25s ease-in-out', */
    background: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff')+' url(img/spaces_toolbar_search.svg?1_0_9606_yabs0uv7t1h) center no-repeat',
    backgroundPosition: '0px center',
    backgroundSize: '32px 32px',
    paddingLeft: '36px',
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box input:hover:enabled, .tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box input:focus', {
    backgroundImage: 'url(img/spaces_toolbar_search_active.svg?1_0_9606_yabs0uv7t1h) !important',
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box input:placeholder-shown', {
    textOverflow: 'ellipsis',
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box .tb-omnibox-press-enter-to-see-all', {
    paddingTop: '7px',
    position: 'absolute',
    right: '14px',
    pointerEvents: 'none',
    fontSize: '14px',
});

cssRule('.tb-omnibox .tb-omnibox-text-box .tb-omnibox-search-box-long input', {
    width: '562px',
});

cssRule('.tb-omnibox-popup', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    backgroundClip: 'padding-box',
    /* error: '-moz-box-shadow': '0 7px 15px rgba(0,0,0,0.2)', */
    '-webkit-box-shadow': '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
    boxShadow: '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
    width: '560px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-no-results', {
    border: '\'none\'',
    padding: '18px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-no-results >.tb-omnibox-no-results-text', {
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: 'normal',
    padding: '6px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-magnifying-icon', {
    background: 'url(img/spaces_toolbar_search.svg?1_0_9606_yabs0uv7t1h) center no-repeat',
    float: 'left',
    height: '30px',
    fontSize: '14px',
    backgroundSize: '32px 32px',
    padding: '0 15px 0 5px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-searchTerm-text', {
    paddingLeft: '10px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-pending-spinner', {
    paddingTop: '18px',
    paddingBottom: '18px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results', {
    overflow: 'auto',
    border: 'none',
    padding: '0 3px',
    fontWeight: 'normal',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed', {
    position: 'relative',
    display: 'block',
    height: '29px',
    lineHeight: '32px',
    fontSize: '14px',
    fontWeight: 500,
    textDecoration: 'none',
    margin: '5px 0 5px 1px',
    padding: '5px 4px 3px',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed.tb-disabled:hover, .tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed.tb-disabled.tb-selected', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed:hover', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    textDecoration: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed:hover >.tb-omnibox-see-all', {
    textDecoration: 'underline',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed.tb-highlighted', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed.tb-selected', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
    textDecoration: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-searchTerm-listed.tb-selected >.tb-omnibox-see-all', {
    textDecoration: 'underline',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-cataloging-error-section', {
    position: 'relative',
    display: 'block',
    height: '29px',
    lineHeight: '29px',
    padding: '14px 6px 14px 6px',
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textAlign: 'center',
    fontSize: '13px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section', {
    overflow: 'hidden',
    marginBottom: '12px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-menu-item-container:hover', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    textDecoration: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-menu-item-container:hover .tb-omnibox-menu-item-name', {
    textDecoration: 'underline',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section:first-child .tb-omnibox-header', {
    borderTop: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header', {
    position: 'relative',
    display: 'block',
    height: '29px',
    lineHeight: '29px',
    fontSize: '15px',
    fontWeight: 400,
    textDecoration: 'none',
    margin: '0 5px 1px',
    padding: '5px 7px 3px',
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#dadada'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header.tb-disabled:hover, .tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header.tb-disabled.tb-selected', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header:hover', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    textDecoration: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header:hover >.tb-omnibox-see-all', {
    textDecoration: 'underline',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header.tb-highlighted', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header.tb-selected', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
    textDecoration: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header.tb-selected >.tb-omnibox-see-all', {
    textDecoration: 'underline',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header .tb-omnibox-section-header-text', {
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    fontSize: '16px',
    fontFamily: '"BentonSans-Medium"',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header .tb-omnibox-section-header-count', {
    paddingLeft: '12px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    font: 'normal 12px BentonSans-Book',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section .tb-omnibox-header .tb-omnibox-see-all', {
    float: 'right',
    margin: '2px 0 0 0',
    fontSize: '12px',
    fontWeight: 'bold',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-horizontal-items', {
    display: 'flex',
    margin: '2px 12px 0',
    justifyContent: 'space-between',
    '-webkit-justify-content': 'space-between',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-metrics .tb-horizontal-items', {
    justifyContent: 'unset',
    '-webkit-justify-content': 'unset',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-vertical-items', {
    margin: '0 10px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-vertical-items .tb-omnibox-menu-item', {
    height: '39px',
    margin: '7px 4px 15px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container', {
    display: 'block',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container:hover .tb-omnibox-menu-item-highlight', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    display: 'block',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container.tb-highlighted .tb-omnibox-menu-item-highlight', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
    display: 'block',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container.tb-selected .tb-omnibox-menu-item-highlight', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
    display: 'block',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-highlight', {
    position: 'absolute',
    left: '-8px',
    right: '-8px',
    top: '-8px',
    bottom: '-8px',
    display: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content', {
    position: 'absolute',
    width: '100%',
    height: '100%',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content .tb-omnibox-popup-section-icon', {
    color: applyColor(DesignTokens.color.font.inverse.default, '#d8d8d8'),
    borderRadius: '2px',
    /* error: '-o-border-radius': '2px', */
    /* error: '-moz-border-radius': '2px', */
    '-webkit-border-radius': '2px',
    /* error: '-khtml-border-radius': '2px', */
    border: 'solid 2px ' + applyColor(DesignTokens.color.component.border.neutral.default.active, '#ebebeb'),
    width: '164px',
    height: '102px',
    boxSizing: 'border-box',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content .tb-omnibox-popup-section-icon.tb-omnibox-popup-workbook', {
    color: applyColor(DesignTokens.color.font.inverse.default, '#d8d8d8'),
    position: 'relative',
    marginBottom: '12px',
    border: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content .tb-omnibox-popup-section-icon.tb-omnibox-popup-workbook [data-tb-test-id="thumbnailImage"]', {
    /* error: '-moz-box-shadow': '0px 1px 2px rgba(0,0,0,0.15)', */
    '-webkit-box-shadow': '0px 1px 2px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0,0,0,0.15)'),
    boxShadow: '0px 1px 2px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0,0,0,0.15)'),
    position: 'absolute',
    width: '100%',
    height: '100%',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content .tb-omnibox-popup-section-icon.tb-omnibox-popup-workbook .tb-omnibox-popup-workbook-icon-content', {
    borderRadius: '2px',
    /* error: '-o-border-radius': '2px', */
    /* error: '-moz-border-radius': '2px', */
    '-webkit-border-radius': '2px',
    /* error: '-khtml-border-radius': '2px', */
    border: 'solid 2px ' + applyColor(DesignTokens.color.component.border.neutral.default.active, '#ebebeb'),
    width: '100%',
    height: '100%',
    position: 'absolute',
    boxSizing: 'border-box',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content .tb-omnibox-popup-section-icon.tb-omnibox-popup-workbook .tb-omnibox-popup-workbook-decorator', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    /* error: '-moz-box-shadow': '0px 1px 2px rgba(0,0,0,0.15)', */
    '-webkit-box-shadow': '0px 1px 2px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0,0,0,0.15)'),
    boxShadow: '0px 1px 2px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0,0,0,0.15)'),
    display: 'block',
    left: '7px',
    position: 'absolute',
    top: '7px',
    bottom: '-4px',
    right: '7px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-content .tb-omnibox-popup-section-icon.tb-omnibox-popup-workbook .tb-omnibox-popup-workbook-decorator:before', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    /* error: '-moz-box-shadow': '0px 1px 2px rgba(0,0,0,0.15)', */
    '-webkit-box-shadow': '0px 1px 2px rgba(0,0,0,0.15)',
    boxShadow: '0px 1px 2px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0,0,0,0.15)'),
    content: '\'\'',
    display: 'block',
    left: '-4px',
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    bottom: '3px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item', {
    position: 'relative',
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    fontWeight: 'bold',
    textDecoration: 'none',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '-webkit-justify-content': 'center',
    flexShrink: 0,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    border: '1px solid transparent',
    backgroundSize: 'contain',
    pointerEvents: 'none',
    width: '36px',
    height: '36px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-datasources-certified', {
    backgroundImage: 'url(img/datasource_certified_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-datasources-not-certified', {
    backgroundImage: 'url(img/datasource_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-flows', {
    backgroundImage: 'url(img/flow_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-tables', {
    backgroundImage: 'url(img/table_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-tables-certified', {
    backgroundImage: 'url(img/table_certified_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-databases', {
    backgroundImage: 'url(img/server_36px-jumbo-copy.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-databases-certified', {
    backgroundImage: 'url(img/server_certified_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-projects', {
    backgroundImage: 'url(img/folder_hollow_open_36px-jumbo.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-icon.tb-publishedConnections', {
    backgroundImage: 'url(img/spaces_search_published_connection.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details', {
    flex: 1,
    '-webkit-flex': 1,
    overflow: 'hidden',
    width: '165px',
    marginTop: '4px',
    paddingLeft: '3px',
    boxSizing: 'border-box',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-name', {
    paddingRight: '3px',
    lineHeight: '20px',
    fontSize: '13px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: '400 14px "BentonSans-Medium"',
    marginBottom: '2px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-owner', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: 'normal 12px BentonSans-Book',
    marginTop: '3px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-owner >.tb-omnibox-menu-item-displayName', {
    marginLeft: '5px',
    fontWeight: 400,
    fontFamily: '"BentonSans-Medium"',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-username', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: applyColor(DesignTokens.color.font.default.secondary, '#4f4f4f'),
    fontSize: '12px',
    fontWeight: 'normal',
    width: '100%',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats', {
    height: '17px',
    lineHeight: '17px',
    paddingRight: '3px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: 'normal 12px \'BentonSans-Book\'',
    marginTop: '3px',
    marginBottom: '2px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat', {
    display: 'inline-block',
    paddingLeft: '8px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-favorite-text', {
    verticalAlign: 'middle',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-text', {
    verticalAlign: 'middle',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    width: '17px',
    height: '17px',
    marginRight: '3px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-icon.tb-favorite', {
    backgroundImage: 'url(img/favorite_selected_12px-xsmall.svg?1_0_9606_yabs0uv7t1h)',
    marginTop: '-1px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-icon.tb-not-favorite', {
    backgroundImage: 'url(img/favorite_unselected_12px-xsmall.svg?1_0_9606_yabs0uv7t1h)',
    marginTop: '-1px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-icon.tb-datasource', {
    backgroundImage: 'url(img/datasource_12px-xsmall.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-icon.tb-sheet', {
    backgroundImage: 'url(img/view_12px-xsmall.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat >.tb-omnibox-menu-item-stat-icon.tb-workbook', {
    backgroundImage: 'url(img/workbook_12px-xsmall.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details >.tb-omnibox-menu-item-stats >.tb-omnibox-menu-item-stat-first', {
    paddingLeft: '0px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item .tb-omnibox-menu-item-details-horizontal', {
    marginLeft: '5px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-vertical', {
    height: '157px',
    width: '164px',
    flexDirection: 'column',
    marginBottom: '14px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-vertical.tb-omnibox-menu-item-workbooks', {
    height: '165px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-horizontal .tb-omnibox-menu-item-content', {
    display: 'flex',
    alignItems: 'center',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-user', {
    height: '57px',
    margin: '4px 4px 11px 4px',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-metrics', {
    height: '60px',
    width: '250px',
    margin: '0 12px 12px 0',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-metrics .tb-omnibox-menu-item-content', {
    alignItems: 'unset',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-metrics .tb-omnibox-popup-metrics-icon', {
    color: applyColor(DesignTokens.color.font.inverse.default, '#d8d8d8'),
    width: '84px',
    height: '70px',
    position: 'relative',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-metrics .tb-omnibox-popup-metrics-icon >div', {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    '-webkit-transform': 'translateY(-50%)',
    /* error: '-moz-transform': 'translateY(-50%)', */
    '-ms-transform': 'translateY(-50%)',
    /* error: '-o-transform': 'translateY(-50%)', */
    height: '100%',
});

cssRule('.tb-omnibox-popup .tb-omnibox-results .tb-omnibox-section-items .tb-omnibox-menu-item-container .tb-omnibox-menu-item-metrics .tb-omnibox-menu-item-details', {
    height: '70px',
});

cssRule('.tb-omnibox-status', {
    position: 'absolute',
    top: '-100px',
});

